import { useEffect } from 'react';

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
  noindex?: boolean;
}

const SEO = ({
  title = 'Tunisie Parking - Parking Intelligent Tunisie',
  description = 'La solution intelligente qui digitalise le stationnement en Tunisie. Gérez vos parkings, réservez votre place et payez facilement.',
  keywords = 'parking tunisie, stationnement intelligent, parking digital, gestion parking, réservation parking, paiement parking',
  image = 'https://parking.tn/og-image.jpg',
  url = 'https://parking.tn',
  type = 'website',
  noindex = false,
}: SEOProps) => {
  useEffect(() => {
    // Mettre à jour le titre
    document.title = title;

    // Fonction helper pour mettre à jour ou créer une meta tag
    const updateMetaTag = (selector: string, attribute: string, value: string) => {
      let element = document.querySelector(selector) as HTMLMetaElement;
      if (!element) {
        element = document.createElement('meta');
        element.setAttribute(attribute === 'name' ? 'name' : 'property', attribute);
        document.head.appendChild(element);
      }
      element.setAttribute('content', value);
    };

    // Meta tags de base
    updateMetaTag('meta[name="description"]', 'name', description);
    updateMetaTag('meta[name="keywords"]', 'name', keywords);
    updateMetaTag('meta[name="robots"]', 'name', noindex ? 'noindex, nofollow' : 'index, follow');

    // Open Graph
    updateMetaTag('meta[property="og:title"]', 'property', title);
    updateMetaTag('meta[property="og:description"]', 'property', description);
    updateMetaTag('meta[property="og:image"]', 'property', image);
    updateMetaTag('meta[property="og:url"]', 'property', url);
    updateMetaTag('meta[property="og:type"]', 'property', type);

    // Twitter Card
    updateMetaTag('meta[property="twitter:title"]', 'property', title);
    updateMetaTag('meta[property="twitter:description"]', 'property', description);
    updateMetaTag('meta[property="twitter:image"]', 'property', image);
    updateMetaTag('meta[property="twitter:url"]', 'property', url);

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement;
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', url);
  }, [title, description, keywords, image, url, type, noindex]);

  return null;
};

export default SEO;

